import * as defaultImport from "@splunk/visualizations/Rectangle";
export * from "@splunk/visualizations/Rectangle";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
